import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import Menue from '../custom_controls/Menue';
import Home from '../components/Home';
//import Home2 from '../components/Home2';
import Contracts from '../components/vas/Contracts';
import Customers from '../components/vas/Customers';
import CustomerCard from '../components/vas/CustomerCard';
import ContractCard from '../components/vas/ContractCard';
import ChangePassword from "../components/ChangePassword";
import Configuration from "../components/Configuration";
import Account from '../components/vas/Account';
import Accounts from '../components/vas/Accounts';
import CreateCustomer from "./vas/CreateCustomer";
import DocumentUpload from "./vas/DocumentUpload";
import DocumentDownload from "./vas/DocumentDownload";
import Footer from '../components/Footer';
import RoleManagement from './RoleManagement';
import ActivateEMail from "../components/ActivateEMail";
import ChangePasswordSuccess from '../components/ChangePasswordSuccess';
import ActivateEMailSuccess from '../components/ActivateEMailSuccess';
import NoPayment from '../components/NoPayment';
import CreatePayment from '../components/vas/CreatePayment';
import CreatePaymentSuccess from '../components/vas/CreatePaymentSuccess';
import CustomerCreateContract from '../components/vas/CustomerCard/CustomerCreateContract';
import CustomerCreateContractSuccess from '../components/vas/CustomerCard/CustomerCreateContractSuccess';
import CreateLegalGuardian from '../components/vas/CustomerCard/CreateLegalGuardian';
import CreateLegalGuardianSuccess from '../components/vas/CustomerCard/CreateLegalGuardianSuccess';
import SchoolHistory from '../components/vas/SchoolHistory';
import ChangeEmail from '../components/vas/CustomerCard/ChangeEmail';
import ChangeEmailSuccess from '../components/vas/CustomerCard/ChangeEmailSuccess';
import CustomerDocumentUpload from '../components/vas/CustomerCard/CustomerDocumentUpload';
import CustomerDocumentUploadSuccess from '../components/vas/CustomerCard/CustomerDocumentUploadSuccess';
import CustomerCertificateUpload from '../components/vas/CustomerCard/CustomerCertificateUpload';
import CustomerCertificateUploadSuccess from '../components/vas/CustomerCard/CustomerCertificateUploadSuccess';
import ContractCancel from '../components/ContractCancel';
import ContractCancelSuccess from '../components/ContractCancelSuccess';
import ContractEditState from '../components/ContractEditState';
import ContractEditStateSuccess from '../components/ContractEditStateSuccess';
import LossReport from '../components/vas/ContractCard/LossReport';
import LossReportSuccess from '../components/vas/ContractCard/LossReportSuccess';
import ErrorOnline from "../components/ErrorOnline";

class Main extends Component
{
    constructor(props){
        super(props);
        this.state = {};
    }

    render(){
        
        let menue=<Menue ref={"Header"} />;
        return (<div>{menue}
          <div style={{ margin: '60px',textAlign:'center' }}>
            <Switch>
              <Route
                path='/home'
                component={Home} />
              <Route
                path='/contracts/:all'
                component={Contracts} />
              <Route
                path='/account'
                component={Account} />
              <Route
                path='/accounts'
                component={Accounts} />
              <Route
                path='/activateEMailSuccess'
                component={ActivateEMailSuccess} />
              <Route
                path='/customers'
                component={Customers} />
              <Route
                path='/customerCard/:id'
                component={CustomerCard} />
              <Route
                path='/contractCard/:contractId/:customerId/:name/'
                component={ContractCard} />
              <Route
                path='/changeMail/:id'
                component={ActivateEMail} />
              <Route
                path='/changePasswordSuccess'
                component={ChangePasswordSuccess} />
              <Route
                path='/changePassword'
                component={ChangePassword} />
              <Route
                path='/createCustomer'
                component={CreateCustomer} />
              <Route
                path='/configuration'
                component={Configuration} />
              <Route
                path='/documentUpload'
                component={DocumentUpload} />
              <Route
                path='/documentDownload'
                component={DocumentDownload} />
              <Route
                path='/roleManagement'
                component={RoleManagement} />
              <Route
                path='/noPayment/:CustomerId'
                component={NoPayment} />
              <Route
                path='/createPayment/:CustomerId/:NewContract'
                component={CreatePayment} />
              <Route
                path='/createPaymentSuccess/:CustomerId'
                component={CreatePaymentSuccess} />
              <Route
                path='/createContract/:CustomerId'
                component={CustomerCreateContract} />
              <Route
                path='/createContractSuccess'
                component={CustomerCreateContractSuccess} />
              <Route
                path='/createLegalGuardian/:CustomerId'
                component={CreateLegalGuardian} />
              <Route
                path='/createLegalGuardianSuccess/:CustomerId'
                component={CreateLegalGuardianSuccess} />
              <Route
                path='/schoolHistory'
                component={SchoolHistory} />
              <Route
                path='/changeEmail/:CustomerId/:Email'
                component={ChangeEmail} />  
              <Route
                path='/changeEmailSuccess/:CustomerId'
                component={ChangeEmailSuccess} />
              <Route
                path='/customerDocumentUpload/:CustomerId'
                component={CustomerDocumentUpload} />
              <Route
                path='/customerDocumentUploadSuccess/:CustomerId'
                component={CustomerDocumentUploadSuccess} />
              <Route
                path='/customerConfirmationsUpload/:CustomerId'
                component={CustomerCertificateUpload} />
              <Route
                path='/customerConfirmationsUploadSuccess/:CustomerId'
                component={CustomerCertificateUploadSuccess} />
              <Route
                path='/contractCancel/:ContractId/:CustomerId/:CustomerName'
                component={ContractCancel} />
              <Route
                path='/contractCancelSuccess/:CustomerId/:ContractId/:CustomerName'
                component={ContractCancelSuccess} />
              <Route
                path='/contractCancel/:ContractId'
                component={ContractCancel} />
              <Route
                path='/contractCancelSuccess'
                component={ContractCancelSuccess} />
             
              <Route
                path='/contractEditState/:CustomerId/:ContractId/:CustomerName'
                component={ContractEditState} />
              <Route
                path='/contractEditStateSuccess/:CustomerId/:ContractId/:CustomerName'
                component={ContractEditStateSuccess} />
              <Route
                path='/lossReport/:CustomerId/:ContractId/:CustomerName'
                component={LossReport} />
              <Route
                path='/lossReportSuccess/:CustomerId/:ContractId/:CustomerName'
                component={LossReportSuccess} />
                <Route                    
                  path='/errorOnline'
                  component={ErrorOnline} />
              <Route
                path=""
                component={Home} />
            </Switch>
          </div>
          <Footer />
        </div>
        );
    }
}
export default Main;
